export default __webpack_public_path__ + "static/creativefx-2-gui-c419435bb767b8ae816365c6f69f338e.png";